
export const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    const day = String(date?.getDate()).padStart(2, '0');
    const month = date?.toLocaleString('en-US', { month: 'short' });
    const year = date?.getFullYear();
    return `${day} ${month} ${year}`;
  };

export const toSentenceCase = (value?: string | null) => {
  const normalized = value?.trim().toLowerCase() ?? "";
  if (!normalized) {
    return "";
  }

  return `${normalized.charAt(0).toUpperCase()}${normalized.slice(1)}`;
};
